'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const utils_clamp = require('../../../utils/clamp.cjs.js');
const utils_headingLevelContext_HeadingLevelContext = require('../../../utils/heading-level-context/HeadingLevelContext.cjs.js');

const HeadingLevel = ({ children }) => {
  const { level } = utils_headingLevelContext_HeadingLevelContext.useHeadingLevel();
  const nextLevel = utils_clamp.clamp(level + 1, 1, 6);
  return jsxRuntime.jsx(utils_headingLevelContext_HeadingLevelContext.HeadingLevelProvider, { level: nextLevel, children });
};

exports.HeadingLevel = HeadingLevel;
//# sourceMappingURL=HeadingLevel.cjs.js.map
